'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class ObjectMetaData {
    constructor(key, name, options) {
        this.key = key;
        this.name = name;
        this.options = options;
    }
}
class FieldMetaData {
    constructor(field, label, type, options, childFields) {
        this.field = field;
        this.label = label;
        this.type = type;
        this.options = options;
        this.childFields = childFields;
    }
}
class ClassMetadata extends ObjectMetaData {
    constructor(key, name, fields, options) {
        super(key, name, options);
        this.fields = fields;
    }
}
class BaseComponentCMSFields {
    constructor() {
        this.isCMSFields = true;
    }
}

exports.BaseComponentCMSFields = BaseComponentCMSFields;
exports.ClassMetadata = ClassMetadata;
exports.FieldMetaData = FieldMetaData;
exports.ObjectMetaData = ObjectMetaData;
//# sourceMappingURL=classes.js.map
